<template>
    <section>
      <nav-component
        :titulo="'Proveedores'"
        :link="{ path: '/formulario-proveedores' }"
        :texto="'Registrar Proveedor'"
      />
      <b-table
        class="box"
        :data="proveedores"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :pagination-rounded="isPaginationRounded"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        default-sort="fecha"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
      
        <b-table-column
          field="nombre"
          label="Nombre"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.nombre }}
        </b-table-column>

        <b-table-column
          field="nit"
          label="nit"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.nit }}
        </b-table-column>
  
        <b-table-column
          field="eps"
          label="Eps"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.eps }}
        </b-table-column>
  
        <b-table-column
          field="direccion"
          label="direccion"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.direccion }}
        </b-table-column>
  
        <b-table-column
          field="telefono"
          label="telefono"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.telefono }}
        </b-table-column>
  
        <b-table-column
          field="observaciones"
          label="Observaciones"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.observaciones }}
        </b-table-column>
  
  
        <b-table-column field="eliminar" label="Eliminar" v-slot="props">
          <b-button
            type="is-danger"
            icon-left="delete"
            @click="eliminar(props.row.id, props.row.nombre)"
          ></b-button>
        </b-table-column>
  
        <b-table-column field="editar" label="Editar" v-slot="props">
          <b-button
            type="is-info"
            icon-left="pencil"
            @click="editar(props.row.id)"
          ></b-button>
        </b-table-column>
      </b-table>
  </section>
  </template>
    
    <script>
  import Swal from "sweetalert2";
  import HttpService from "../../Servicios/HttpService";
  import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";
  import NavComponent from "../Extras/NavComponent";
  
  export default {
      mixins: [NotificacionesMixin],
      components: { NavComponent },
  
    data: () => ({
      isPaginated: true,
      isPaginationSimple: false,
      isPaginationRounded: true,
      paginationPosition: "bottom",
      defaultSortDirection: "desc", // Cambiado a "desc" para ordenar de manera descendente
      sortIcon: "arrow-up",
      sortIconSize: "is-medium",
      currentPage: 1,
      perPage: 20,
      proveedores: [],
    }),
  
    mounted() {
      this.obtenerProveedores();
    },
  
    methods: {
  
        obtenerProveedores() {
        let payload = {
          accion: "obtenerProveedores",
        };
        HttpService.obtenerConConsultas("reportes.php", payload).then(
          (transacciones) => {
            this.proveedores = transacciones;
          }
        );
      },
      eliminar(id, nombre) {
        Swal.fire({
          title: "¿Estás seguro?",
          text: "¡No podrás revertir esto! Se eliminarán todo lo relacionado de " + nombre,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminarlo",
        }).then((result) => {
          if (result.isConfirmed) {
            HttpService.eliminar("reportes.php", {
              accion: "eliminarProveedor",
              id: id,
            }).then((resultado) => {
              if (!resultado) {
                this.mostrarNotificacion('error', "Error al eliminar");
                this.cargando = false;
                return;
              }
              this.mostrarNotificacion('success', "Proveedor eliminado");
              this.cargando = false;
              this.obtenerProveedores();
            }).catch(() => {
              this.mostrarNotificacion('error', "Error al eliminar");
              this.cargando = false;
            });
          }
        });
      },
      editar(id) {
        this.$router.push({
          name: "FormularioProveedoresEditar",
          params: { id: id },
        });
      },
    },
  };
  </script>
    
    